var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.47266 0.761718L2.41406 0.817968V1.44141V2.0625H1.45547C0.522656 2.0625 0.496875 2.06484 0.435938 2.11172L0.375 2.15859V6.21797C0.375 8.94609 0.384375 10.3078 0.398438 10.3711C0.517969 10.8258 0.876563 11.1727 1.33125 11.2711C1.42031 11.2898 2.71172 11.2969 6.00703 11.2969C9.98438 11.2969 10.5773 11.2922 10.7086 11.2617C11.1234 11.1633 11.4633 10.8328 11.5875 10.4086C11.6203 10.2937 11.625 9.81094 11.625 5.54062V0.799218L11.5641 0.752343L11.5008 0.703125H7.01484H2.52891L2.47266 0.761718ZM11.2453 5.66484L11.2383 10.2305L11.1844 10.3641C11.1141 10.5398 10.9594 10.7086 10.7766 10.807L10.6289 10.8867L6.56484 10.8937L2.50078 10.8984L2.55938 10.8234C2.59219 10.7812 2.64609 10.6898 2.68125 10.6242C2.81953 10.35 2.8125 10.6172 2.8125 5.65312V1.10156H7.03125H11.25L11.2453 5.66484Z",
    fill: "#091F28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20703 2.23823L4.14844 2.29448V3.18511V4.07573L4.20469 4.14136L4.26094 4.20698L6.97266 4.21401C8.46328 4.21636 9.71719 4.21167 9.75703 4.19995C9.80859 4.18823 9.84375 4.15776 9.87188 4.10151C9.90938 4.02886 9.91406 3.93276 9.91406 3.19683C9.91406 2.34839 9.90469 2.24761 9.82031 2.20308C9.79219 2.18901 8.77266 2.17964 7.01953 2.17964H4.26328L4.20703 2.23823Z",
    fill: "#091F28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.19759 5.26409C4.12962 5.35081 4.13431 5.46331 4.20931 5.53362L4.27024 5.58987L7.00306 5.59456C9.17806 5.59925 9.74993 5.59456 9.79681 5.57112C9.88587 5.52659 9.92337 5.4305 9.89056 5.33206C9.87649 5.28753 9.84368 5.23831 9.82024 5.22659C9.79212 5.21253 8.79603 5.20315 7.01009 5.20315H4.24446L4.19759 5.26409Z",
    fill: "#091F28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24931 6.5625C4.13681 6.60703 4.11337 6.78516 4.20712 6.87891L4.26337 6.9375H7.01728H9.77118L9.83446 6.88125C9.92587 6.80391 9.92587 6.67266 9.83446 6.59531L9.77118 6.53906L7.03603 6.54141C5.51962 6.54141 4.27743 6.55078 4.24931 6.5625Z",
    fill: "#091F28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.19766 7.95937C4.16953 7.99453 4.14844 8.05078 4.14844 8.08594C4.14844 8.12109 4.16953 8.17734 4.19766 8.2125L4.24453 8.27344H7.01016C8.77031 8.27344 9.79219 8.26406 9.82031 8.25C9.92109 8.19609 9.92109 7.97578 9.82031 7.92187C9.79219 7.90781 8.77031 7.89844 7.01016 7.89844H4.24453L4.19766 7.95937Z",
    fill: "#091F28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20693 9.29297C4.13428 9.36328 4.12959 9.4875 4.19287 9.56484L4.2374 9.62109L7.00303 9.62812L9.77099 9.63281L9.83428 9.57656C9.92568 9.49922 9.92568 9.36797 9.83428 9.29062L9.77099 9.23437H7.01709H4.26318L4.20693 9.29297Z",
    fill: "#091F28"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.ca7e040c25936460176acc816c77f9b6.svg";
export { ForwardRef as ReactComponent };